module.exports = __webpack_public_path__ + "img/partner-new-icon9.7d0b9556.svg";